<!--
@component
Results

See markup below.
-->

<script lang="ts">
  import { Block } from '@reuters-graphics/graphics-components';
  import MatchStrip from '$lib/components/common/MatchStrip/index.svelte';
  import MatchStripPlaceholder from '$lib/components/common/MatchStrip/Placeholder.svelte';
  import LazyMount from '$lib/components/common/LazyMount/index.svelte';
  import { getMatches } from '$utils/getGroups';
  import { fly } from 'svelte/transition';

  /** Reserved height for off-screen MatchStrip rows. */
  const MATCH_CARD_HEIGHT = 'calc(3.75 * var(--theme-font-size-base))';

  /* Matches data from API */
  let { data } = $props();

  /**
   * Group-stage matches bucketed by group.
   */
  const matchesByGroup = $derived(getMatches(data.matches));
</script>

<!--
  Placeholder shown while a match row is off-screen. Mirrors the rendered
  `MatchStrip` footprint so swapping in the live strip via `LazyMount`
  doesn't shift layout. The per-row live-region is suppressed
  (`label={null}`) because each group `<ol>` already labels its own list.
-->
{#snippet placeholder()}
  <MatchStripPlaceholder label={null} />
{/snippet}

<Block width="widest">
  <ul class="mx-auto flex flex-wrap justify-center">
    <!-- One column per group -->
    {#each matchesByGroup as group (group.groupName)}
      <li class="column" in:fly|global={{ y: -5, duration: 500 }}>
        <h2 class="h4 mt-0">{group.groupName}</h2>

        <!-- Matches ordered by date -->
        <ol class="mb-0">
          {#each group.matches as match, i (match.matchInfo?.id ?? i)}
            <li
              class="fmy-2"
              in:fly|global={{
                y: -15,
                duration: 500,
                delay: Math.min((i + 1) * 50, 1000),
              }}
            >
              <LazyMount height={MATCH_CARD_HEIGHT} {placeholder}>
                <MatchStrip {match} link={true} />
              </LazyMount>
            </li>
          {/each}
        </ol>
      </li>
    {/each}
  </ul>
</Block>

<style lang="scss">
  @use '../layout.scss';
</style>
